import { render } from "./BakedProducts.vue?vue&type=template&id=78e7e782&scoped=true"
import script from "./BakedProducts.vue?vue&type=script&lang=js"
export * from "./BakedProducts.vue?vue&type=script&lang=js"

import "./BakedProducts.vue?vue&type=style&index=0&id=78e7e782&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e7e782"]])

export default __exports__